import { Navigate } from 'react-router-dom';
import { useAdminAuth } from 'contexts/AdminAuthContext';
import Loader from 'components/Loader';

export default function AuthGuard({ children }) {
  const { isAuthenticated, isLoading } = useAdminAuth();

  if (isLoading) return <Loader />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return children;
}
